module.exports = __webpack_public_path__ + "static/media/crow_dropping_stone.17824550.gif";